import React, { useState, useEffect, useRef } from 'react';
import QRCode from 'qrcode.react'; 
import { QRCodeSVG } from 'qrcode.react';
import { useNavigate, useLocation } from 'react-router-dom';
import BB from './images/BB.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faArrowLeft, faCaretLeft, faChevronDown, faTrash } from '@fortawesome/free-solid-svg-icons';
import ShoppingTrolly from './images/ShoppingTrolly.png';
import BCicon from './images/BCicon.png';
import Info from './images/Infoimg.png';
import { XCircle } from "lucide-react"; // or any icon you prefer
import User from './images/User.png';
import PhoneSpinner from './images/PhoneSpinner.png';
import CheckIcon from './images/CheckIcon.png';
import Building from './images/Building1.png';
import GoogleMap from './images/GoogleMap.png';
import Walleticon from './images/Walleticon.png';
import BuildCoin from './images/buildcoin.png';
import COD from './images/codIcon.png';
import ListView from './images/ListView.png';
import DeliveFood from './images/DeliverFood.png';
import Coininhand from './images/Coininhand.png';
import File from './images/File.png';
import ManualHandling from './images/ManualHandling.png';
import scooterwithdeliverybag from './images/scooterwithdeliverybag.png';
import ArrowLeft from './images/ArrowLeft.png';
import Share from './images/Share.png';
import VerifiedAccount from './images/VerifiedAccount.png';
import { useNotification } from '../context/NotificationContext';
import Map from './images/Map.png';
import Boxwithclockimg from './images/Boxwithclockimg.png';
import PaymentCountdown from './Component/PaymentCountdown';
import { Clock } from "lucide-react"; // or any clock icon you use
import ChangeLocationPopup from './Component/ChangeLocationPopup';
import HeaderBar from './Component/Header2';

const OrderDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { quotationId, order_id } = location.state || {};
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const [quotationData, setQuotationData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showOrderDetails, setShowOrderDetails] = useState(true);
  const [project, setProject] = useState(null);

  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const imageUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES;
  //const [notifications, setNotifications] = useState([]);
  const { notifications, setNotifications } = useNotification();
  const [fetchedNotifications, setFetchedNotifications] = useState(false);

//console.log("----notifications:------",notifications);
const [showSharePopup, setShowSharePopup] = useState(false);
const [showReturnPopup, setShowReturnPopup] = useState(false);
const [selectedReturnItems, setSelectedReturnItems] = useState([]);

const [showLocationPopup, setShowLocationPopup] = useState(false);
const [projects, setProjects] = useState([]);
 const [deliveryAddress, setDeliveryAddress] = useState(null); 
const [deliveryAddresses, setDeliveryAddresses] = useState([]);
const [showReasonPopup, setShowReasonPopup] = useState(false);
const [selectedReason, setSelectedReason] = useState('');
const [showCancelPopup, setShowCancelPopup] = useState(false);
const [showCancelSection, setShowCancelSection] = useState(true);
 const [allUOMs, setAllUOMs] = useState([]);
  const backendApiUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
 const paymentCompleted = quotationData?.payment_status === 'Paid';
 const [showNotificationLoader, setShowNotificationLoader] = useState(false);
const [payNowLoading, setPayNowLoading] = useState(false);
const [showPayNowButton, setShowPayNowButton] = useState(false);
const isFinalBill = quotationData?.data_source === "sales_order";
const deliveryCharge = isFinalBill ? 200 : 0;
const handlingCharge = isFinalBill ? 10 : 0;
const computedGrandTotal =
  (Math.round(quotationData?.total) || 0) + deliveryCharge + handlingCharge;
const [catgories,setCategories] = useState([]);
const [brands, setBrands] = useState([]);

const [rewardableCoins, setRewardableCoins] = useState(0);
const [redeemableCoins, setRedeemableCoins] = useState(0);
const [checked, setChecked] = useState(true);
const [redeemableItems,setRedeemableItems] = useState([]);


  const allowedStatuses = ["order confirmed"]; // Add if not present already

const allowAvailabilityStyling = allowedStatuses.includes(
  (quotationData?.status || "").toLowerCase().trim()
);

const isDelivered = quotationData?.delivery_groups?.some(
  group => group?.delivery_group_status === "Delivered"
);

 useEffect(() => {
  if (quotationId || order_id) {
    fetchQuotationDetails();
  }
  // Get project from sessionStorage
  const projectData = JSON.parse(sessionStorage.getItem('project'));
  setProject(projectData);
}, [quotationId, order_id]);

useEffect(() => {
  if (quotationData?._id) {
    fetchOrderNotifications();
  }
}, [quotationData?._id]);

useEffect(() => {
  if (
    quotationData?.payment_status === "Ready to Pay" &&
    !showPayNowButton
  ) {
    setShowPayNowButton(true);
  }
}, [quotationData]);


useEffect(() => {
  console.log("Notifications updated:", notifications);
  if (notifications.length > 0 && quotationData?._id) {
    const userData = JSON.parse(sessionStorage.getItem('userData'));

    // ✅ Find notifications that belong to this order
    const matchingNotifications = notifications.filter(notif => {
      const orderId1 = notif?.data?.order_id;
      const orderId2 = notif?.order_id;
      const entityId = notif?.entityId;
      const userId = notif?.recipientId;

      console.log("Checking notification:", notif);

      return (
        orderId1 === `"${quotationData._id}"` ||
        orderId1 === quotationData._id ||
        orderId2 === `"${quotationData._id}"` ||
        orderId2 === quotationData._id ||
        (entityId === quotationData._id &&
          userId?.toString() === userData?._id?.toString())
      );
    });

    if (matchingNotifications.length > 0) {
      // Check if notification has "Ready To Pay" status
      const hasReadyToPayStatus = matchingNotifications.some(notif => {
        const paymentStatus =
          notif?.data?.payment_status || notif?.metadata?.payment_status;
        return paymentStatus === "Ready To Pay";
      });

      setShowNotificationLoader(true);
      setTimeout(() => {
        setShowNotificationLoader(false);
        if (hasReadyToPayStatus) {
          setShowPayNowButton(true);
        }
      }, 1000);

      // ✅ Always refresh quotation when any new notification comes
      fetchQuotationDetails();

      // Clear old fetched notifications
      setFetchedNotifications([]);
    }
  }
}, [notifications, quotationData?._id]);


useEffect(() => {
  if (location?.state?.appliedCoins && location?.state?.ledgerId) {
    // You can also refetch quotation here if needed
    setQuotationData(prev => ({
      ...prev,
      discount: location.state.appliedCoins
    }));
  }
}, [location?.state?.appliedCoins, location?.state?.ledgerId]);


useEffect(() => {
    fetchAllUOMs();
  }, []);


// Update the existing useEffect that fetches quotation details
useEffect(() => {
  if (quotationId) {
    fetchQuotationDetails();
  }
  // Get project from sessionStorage
  const projectData = JSON.parse(sessionStorage.getItem('project'));
  setProject(projectData);
}, [quotationId]);



const fetchAllUOMs = async () => {
    const token = sessionStorage.getItem('token');
    const response = await fetch(`${backendApiUrl}UOMs/get-all-UOMs`, {
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      }
    });
    const data = await response.json();
    if (data.status === 200 || data.status === 201) {
      setAllUOMs(data.data);
    }
    console.log(data);
  };

 const fetchOrderNotifications = async () => {
  try {
    setLoading(true);
    const userData = JSON.parse(sessionStorage.getItem('userData'));
    const userId = userData?._id;
    const token = userData?.token || sessionStorage.getItem('token');
    
    if (!userId) {
      console.log('No userId found');
      return;
    }
    
    if (!quotationData?._id) {
      console.log('No quotationData._id found');
      return;
    }

    const response = await fetch(
      `${fetchUrl}customer/quotations/get-consumer-live-order-notifications?userId=${userId}&orderId=${quotationData._id}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      }
    );

    const data = await response.json();
    console.log('Fetched order notifications:', data);
    
    if (data.success && data.data) {
      // Filter notifications that match current order ID
      const matchingNotifications = data.data.filter(notif => {
        // Check multiple possible locations for order_id
        const orderId1 = notif.order_id;
        const orderId2 = notif.metadata?.order_id;
        const entityId = notif.entityId;
        
        return orderId1 === `"${quotationData._id}"` ||
               orderId1 === quotationData._id ||
               orderId2 === `"${quotationData._id}"` ||
               orderId2 === quotationData._id ||
               entityId === quotationData._id;
      });
      
      console.log('Matching fetched notifications:', matchingNotifications);
      // Set the matching fetched notifications
      setFetchedNotifications(matchingNotifications);
    }
  } catch (error) {
    console.error('Error fetching order notifications:', error);
  }
  finally {
    setLoading(false);
  }
};


// Add this function to handle cancel order
const handleCancelOrder = () => {
  setShowCancelPopup(true);
};


useEffect(() => {
  if (quotationData?.product_categories) {
    // Extract all category names
    const categories = quotationData.product_categories.map(cat => cat.product_category_name);

    // Extract all manufacturer names (brands) from all items in all categories
    const brands = quotationData.product_categories
      .flatMap(cat => cat.items?.map(item => item.manufacturer_name).filter(Boolean))
      .filter((value, index, self) => self.indexOf(value) === index);

    // You can set these to state if you want to use them elsewhere
     setCategories(categories);
     setBrands(brands);
       // Extract all items from all categories into one array
  const allItems = quotationData.product_categories.flatMap(cat => cat.items || []);

     if(brands && categories){
      fetchRewards(allItems);
      getApplicableBuildcoins(allItems);
     }
  }
}, [quotationData]);

const getApplicableBuildcoins = async (updatedItems) => {

  const userData = JSON.parse(sessionStorage.getItem('userData'));
    const customerId = userData?._id;
    const token = userData?.token;

    const processedItems = updatedItems.map(item => ({
      _id: item.item_id,
      name: item.item_name,
      price: item.selling_price || 0,
      quantity: item.quantity,
    }));

    console.log("processedItems:",processedItems)


    const totalAmount =  Math.round(processedItems.reduce((total, item) => total + (item.price * item.quantity) + (item.price * 0.18 * item.quantity), 0));
    console.log('Total amount for rewards:', totalAmount);

  const context = {
    consumer_id: customerId,
    items: processedItems,
    totalAmount: totalAmount,
    brand: brands,
    category: catgories,
    partner_id: '6889abb0dc50d682fe38fae2',
  };
  console.log('Reward calculation context:', context);
  try {
    //const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}rewards/get-applicable-buildcoins-from-wallet?consumer_id=${consumer_id}&category=${category}&brand=${brand}&is_ecommerce=${is_ecommerce}&amount=${cartTotal}&partner_id=${partner_id}`, {
      //method: 'GET',
   const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}rewards/calculate-redeem-coins`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      },
      body: JSON.stringify(context)
    });
           
    const data = await response.json();
    console.log("fetched applicable coins:",data)
    //setWalletCoinsApplicable(data?.applicable_coins)
    //setCoinLedger(data[0]);
    //setCoinLedgers(data ? data.applicable_coins : []);
    //setRedeemableCoins(data?.total_usable_coins);
      setRedeemableCoins(data?.data.rewards[0]?.coins || 0);
      setRedeemableItems(data?.data.items_coins)

  } catch (err) {
    console.error('Error getting buildcoins wallet:', err);
  }
}; 

const fetchRewards = async (updatedItems) => {
  console.log('Calculating rewards for items:', updatedItems);
  const userData = JSON.parse(sessionStorage.getItem('userData'));
    const customerId = userData?._id;
    const token = userData?.token;

    const processedItems = updatedItems.map(item => ({
      _id: item.item_id,
      name: item.item_name,
      price: item.selling_price || 0,
      quantity: item.quantity,
    }));



    const totalAmount =  Math.round(processedItems.reduce((total, item) => total + (item.price * item.quantity) + (item.price * 0.18 * item.quantity), 0));


  const context = {
    consumer_id: customerId,
    items: processedItems,
    totalAmount: totalAmount,
    brand: brands,
    category: catgories,
    items: processedItems,
    partner_id: '6889abb0dc50d682fe38fae2',
  };
  console.log('Reward calculation context:', context);
try{
   const endpoint = `${fetchUrl}rewards/calculate-reward-coins`;
    const method = 'POST';

    // Send to backend
    const response = await fetch(endpoint, {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
      body: JSON.stringify(context)
    });

    const data = await response.json();
    console.log('📊 Backend response for coins:', data);
      setRewardableCoins(data.data.total_coins);
      return { 
        success: true
      };
  } catch (error) {
    console.error('Error calculating reward coins:', error);
    return { success: false, message: 'An error occurred while calculating the rewards' };
  }
};

 const fetchQuotationDetails = async () => {
  try {
    setLoading(true);
    const token = sessionStorage.getItem('token');
    console.log('🔍 Fetching quotation with token:', token); 
    
    const response = await fetch(`${fetchUrl}customer/quotations/get-quotation-by-its-id?quotation_id=${quotationId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
    });

    const data = await response.json();
    //console.log(' Quotation Data Response:', data);
    
    if (data.success) {
      setQuotationData(data.data);
      localStorage.setItem('quotationId', data.data._id);
      console.log('Quotation Data Set:', data.data);
      if (data.data.delivery_address_id) {
       // console.log('Calling fetchDeliveryAddress with ID:', data.data.delivery_address_id);
        await fetchDeliveryAddress(data.data.delivery_address_id);
      } else {
        console.log(' No delivery_address_id found in quotation data');
      }
    } else {
      console.error('Failed to fetch quotation:', data.message);
    }
  } catch (error) {
    console.error(' Error fetching quotation:', error);
  } finally {
    setLoading(false);
  }
};

  const fetchDeliveryAddress = async (addressId) => {
  try {
    const token = sessionStorage.getItem('token');

    const response = await fetch(`${fetchUrl}customer/delivery-address/getDeliveryAddressById?address_id=${addressId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
    });

    const data = await response.json();    
    if (data.success) {
      setDeliveryAddress(data.data);
      console.log(' Delivery Address Set:', data.data);
    } else {
      console.error(' Failed to fetch delivery address:', data.message);
    }
  } catch (error) {
    console.error(' Error fetching delivery address:', error);
  }
 
};


  // Handle clicks outside the menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

 if (loading) {  
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-opacity-70 backdrop-blur-sm z-50">
      {/* 🔴 Red spinning circle */}
      <div className="w-8 h-8 border-2 border-red-400 border-t-transparent rounded-full animate-spin"></div>
      
      {/* Text below loader */}
      <p className="mt-4 text-gray-400  text-xs">Loading Order Details...</p>
    </div>
  );
}


  if (!quotationData) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <p>Order details not found</p>
        </div>
      </div>
    );
  }
 


const handleOtherShare = (platform) => {
  const totalAmount = quotationData.total;
  const message = `Check out my order from BrickBucket! Order ID: ${quotationData.quotation_number}, Total: ₹${totalAmount?.toLocaleString()}`;
  
  switch(platform) {
    case 'telegram':
      window.open(`https://t.me/share/url?url=${encodeURIComponent(window.location.href)}&text=${encodeURIComponent(message)}`, '_blank');
      break;
    case 'facebook':
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`, '_blank');
      break;
    case 'twitter':
      window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}&url=${encodeURIComponent(window.location.href)}`, '_blank');
      break;
    case 'copy':
      navigator.clipboard.writeText(`${message}\n${window.location.href}`);
      alert('Link copied to clipboard!');
      break;
  }
  setShowSharePopup(false);
};

const handleReturnItemSelect = (itemId) => {
  setSelectedReturnItems(prev => {
    if (prev.includes(itemId)) {
      return prev.filter(id => id !== itemId);
    } else {
      return [...prev, itemId];
    }
  });
};

// Add this function to handle return submission
const handleReturnSubmit = () => {
  if (selectedReturnItems.length === 0) {
    alert('Please select at least one item to return');
    return;
  }
  
  // Close the return items popup and open reason popup
  setShowReturnPopup(false);
  setShowReasonPopup(true);
};

const handleReasonSelect = (reason) => {
  setSelectedReason(reason);
};

const handleFinalReturnSubmit = () => {
  if (!selectedReason) {
    alert('Please select a reason for return');
    return;
  }
  
  console.log('Items to return:', selectedReturnItems);
  console.log('Return reason:', selectedReason);
  
  // Add your return logic here
  setShowReasonPopup(false);
  setSelectedReturnItems([]);
  setSelectedReason('');
};


 return (
  <div className="min-h-screen flex flex-col bg-[#F5F5F5]">
  
<div className="mb-4">
  <HeaderBar
    title="Order Details"
    showSearch={false}
  />
</div>


 <div className="mx-4 mb-4">
  <div className="bg-white p-2 pb-2 rounded-md shadow-sm flex flex-col space-y-3 relative">
    {showNotificationLoader ? (
      <div className="text-center py-8">
        <img
          src={PhoneSpinner}
          alt="Loading"
          className="h-16 w-16 object-contain mx-auto animate-spin"
        />
        <p className="text-[#666666] text-sm mt-2">Loading...</p>
      </div>
    ) : (
      <>
        {(() => {
          const realtimeMatching = notifications.filter(notif => {
            const orderId1 = notif?.data?.order_id;
            const orderId2 = notif?.order_id;
            const entityId = notif?.entityId;

            return orderId1 === `"${quotationData._id}"` ||
                   orderId1 === quotationData._id ||
                   orderId2 === `"${quotationData._id}"` ||
                   orderId2 === quotationData._id ||
                   entityId === quotationData._id;
          });

          let currentNotification = null;
          if (realtimeMatching.length > 0) {
            const sortedRealtime = realtimeMatching.sort((a, b) => {
              const timeA = new Date(a.trigger_time || a.timestamp || 0);
              const timeB = new Date(b.trigger_time || b.timestamp || 0);
              return timeB - timeA;
            });
            currentNotification = sortedRealtime[0];
          } else if (fetchedNotifications.length > 0) {
            const sortedFetched = fetchedNotifications.sort((a, b) => {
              const timeA = new Date(a.sentAt || a.createdAt || a.metadata?.trigger_time || 0);
              const timeB = new Date(b.sentAt || b.createdAt || b.metadata?.trigger_time || 0);
              return timeB - timeA;
            });
            currentNotification = sortedFetched[0];
          }

          const data = currentNotification?.data || currentNotification?.metadata || currentNotification;
          const paymentStatus = data?.payment_status;
          const awardStatus = data?.award_status;
          const supplierStatus = data?.supplier_status || data?.status;

          // 👉 Commenting this line to always show progress bar
          // if (supplierStatus === 'Accepted') return null;

          const shouldShowProgressBar = paymentStatus !== 'paid' && awardStatus !== 'Awarded';
        })()}
        {(() => {  
          const realtimeMatching = notifications.filter(notif => {
            const orderId1 = notif?.data?.order_id;
            const orderId2 = notif?.order_id;
            const entityId = notif?.entityId;
                           
            return orderId1 === `"${quotationData._id}"` ||
                   orderId1 === quotationData._id ||
                   orderId2 === `"${quotationData._id}"` ||
                   orderId2 === quotationData._id ||
                   entityId === quotationData._id;
          });

          let currentNotification = null;
          if (realtimeMatching.length > 0) {
            const sortedRealtime = realtimeMatching.sort((a, b) => {
              const timeA = new Date(a.trigger_time || a.timestamp || 0);
              const timeB = new Date(b.trigger_time || b.timestamp || 0);
              return timeB - timeA;
            });
            currentNotification = sortedRealtime[0];
          } else if (fetchedNotifications.length > 0) {
            const sortedFetched = fetchedNotifications.sort((a, b) => {
              const timeA = new Date(a.sentAt || a.createdAt || a.metadata?.trigger_time || 0);
              const timeB = new Date(b.sentAt || b.createdAt || b.metadata?.trigger_time || 0);
              return timeB - timeA;
            });
            currentNotification = sortedFetched[0];
          }

          if (!currentNotification) return null;

          const data = currentNotification.data || currentNotification.metadata || currentNotification;
                             
          if (!data) return null;
                     
          
          const paymentStatus = data?.payment_status;
          const showTrackOrderButton = paymentStatus === 'paid' || paymentStatus === 'Paid';

          let messagePayload = null;
          try {
            if (typeof data.messagePayload === 'string') {
              messagePayload = JSON.parse(data.messagePayload);
            } else {
              messagePayload = data.messagePayload;
            }
          } catch (e) {
           // console.log('Error parsing messagePayload:', e);
          }

          const latestMessage = messagePayload?.latestMessage;
          const summaryMessage = messagePayload?.summaryMessage;

          if (latestMessage || summaryMessage) {
            return (
              <div className="text-center pt-2 mx-4">
                {latestMessage && (
                  <p className="text-[#000000] text-md font-medium mb-3">{latestMessage}</p>
                )}
                {summaryMessage && (
                  <p className="text-[#666666] text-xs mb-2">{summaryMessage}</p>
                )}
                              
              </div>
            );
          }

          return null;
        })()}
      </>
    )}
  </div>
</div>

{quotationData?.earned &&
  (quotationData?.payment_status || quotationData?.paymentStatus)?.trim().toLowerCase() !== "payment timeout" && (
    <span className="text-sm text-green-600 font-medium text-center mb-2 bg-white rounded-md shadow-sm py-4 mx-4 mb-4">
      Yay! You earned {quotationData.earned} BuildCoins on this order!
    </span>
  )}



<div className="mx-4 mb-4">
  {quotationData.payment_status === "Paid" ? (
    // === Show Delivery Groups UI if Payment is Done ===
    quotationData.delivery_groups?.map((group, groupIndex) => (
      <div
        key={group.delivery_group_id || groupIndex}
        className="bg-white rounded-md shadow-sm p-4 mb-4"
      >
        {/* Order Header */}
        <div className="flex justify-between items-center mb-3">
          <h4 className="text-lg font-semibold text-gray-900">
           Order Items {/* Order: {group.readable_order_number} */}
          </h4>
        </div>
        <div className="border-b border-gray-200 mb-3" />

        {/* Loop through delivery categories */}
        {group.delivery_categories?.map((category, categoryIndex) => (
          <div key={categoryIndex} className="mb-4">
            <h4 className="text-sm font-semibold text-gray-800 mb-4">
              {category.product_category_name}
            </h4>
            <div className="space-y-3">
              {category.items.map((item, itemIndex) => (
                <div key={item.item_id || itemIndex} className="flex items-start">
                  {/* Image or fallback */}
                  <div className="bg-gray-100 rounded-md p-2 mr-3 flex-shrink-0">
                <img
                  src={imageUrl + item.item_image}
                  alt={item.item_name}
                  className="h-12 w-12 object-contain"
                />
                  </div>

                  {/* Product Info */}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center mb-1 mt-1">
                      <span className="text-sm font-medium text-gray-900 line-clamp-2">
                        {item.item_name}
                      </span>
                    </div>
                    {/* <div className="text-[11px] text-[#092C83] font-medium">
                       {item.quantity} {allUOMs.find((uom) => uom._id === item.UOM_id)?.UOM || "unit"}
                    </div> */}
                   <div className="text-[12px] text-gray-500 ">
                   ₹{item.selling_price} x {item.quantity} {item.UOM || "qty"}
                  </div>
                  </div>

                  {/* Price and PO Number */}
                  <div className="flex flex-col items-end ml-3 mt-2">
                    <div className="text-sm font-bold text-[#170101]">
                      ₹{Math.round(item.selling_price * item.quantity).toLocaleString()}
                    </div>
                  
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}

        {/* Track Items Button */}
        <div className="border-b border-gray-200 my-3" />
        <div className="flex items-center justify-between">
          <div className="flex flex-col items-start">
          {(() => {
    const status = quotationData?.delivery_groups?.[0]?.delivery_group_status;

    if (status === 'Out For Delivery') {
      return (
        <div className="flex flex-col items-start">
          <span className="text-sm text-[#000000] font-semibold flex items-center">
            🚚 Out for Delivery
          </span>
          <span className="text-xs text-gray-500">
            Your order is on the way
          </span>
        </div>
      );
    }

    if (status === 'Delivered') {
      return (
        <div className="flex flex-col items-start">
          <span className="text-sm text-green-600 font-semibold flex items-center">
            ✅ Delivered
          </span>
          <span className="text-xs text-gray-500">
            Thank you for your order!
          </span>
        </div>
      );
    }

   if (status === 'Pending' || status === 'Delivery Group Created') { 
         return (
        <div className="flex flex-col items-start">
           <span className="text-sm text-[#A8A1A1] font-semibold">
              Estimated delivery in
            </span>
            <span className="text-sm text-[#524D4D] font-semibold">2 Hours</span>
        </div>
      );
    }

    return null;
  })()}

          </div>
        {quotationData?.delivery_groups?.[0]?.delivery_group_status !== 'Delivered' && (
    <button
      onClick={() =>
        navigate("/consumer/trackitems", {
          state: {
            quotationId: quotationData._id,
            deliveryGroupId: group.delivery_group_id,
          },
        })
      }
      className="border border-[#f84c5c] text-[#F84C5C] font-semibold text-md px-4 py-2 rounded-md transition-colors duration-200 shadow-sm text-sm"
    >
      Track Items
    </button>
  )}
        </div>
      </div>
    ))
  ) : (
    // === Show Product Categories UI if Not Paid ===     
    quotationData.product_categories?.map((category, categoryIndex) => {
      const categoryTotal = Math.round(category.category_total);
      return (
        <div
          key={categoryIndex}
          className="bg-white rounded-md shadow-sm p-4 mb-4"
        >
          {/* Category Header */}
          <div className="flex justify-between items-center mb-3">  
            <h4 className="text-sm font-semibold text-[#000000]">
              {category.product_category_name}
            </h4>
            <div className="flex items-center">
              <span className="text-sm font-semibold text-[#170101]">
                ₹{categoryTotal.toLocaleString()}
              </span>
            </div>
          </div>
          <div className="border-b border-gray-200 mb-3" />

          {/* Items in Category */}
          <div className="space-y-3">
          {category.items.map((item, itemIndex) => {
  const isUnavailableRaw = item.item_availability === false;
  const isUnavailable =  
    allowAvailabilityStyling && isUnavailableRaw;       

  const uomLabel =
    allUOMs.find((uom) => uom._id === item.UOM_id)?.UOM || "unit";

  const orderedQty = Number(item?.order_placed_quantity ?? 0);
  const confirmedQty = Number(item?.quantity ?? 0);
  const qtyDecreased = item?.quantity_changed && confirmedQty < orderedQty;

  return (
    <div
      key={itemIndex}
      className={`flex items-start ${isUnavailable ? "opacity-50 grayscale" : ""}`}
    >
      {/* Product Image */}
      <div className="bg-gray-100 rounded-md p-2 mr-3 flex-shrink-0 h-12 w-12 flex items-center justify-center relative">
        <img
          src={imageUrl + item.item_image}
          alt={item.item_name}
          className="h-12 w-12 object-contain absolute"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.parentNode.innerHTML += '<span class="text-gray-400 text-center text-xs">No Image</span>';
          }}
        />
      </div>

      {/* Product Info */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center mb-1 mt-2">
          <span className="text-[13px] text-[#000000] leading-tight">
            {item.item_name}
          </span>
          {item.price_changed && (
            <div className="w-1.5 h-1.5 ml-2 rounded-full bg-[#EF4444]"></div>
          )}
        </div>

<div className="text-[13px] text-[#000000] leading-tight">
  {checked && redeemableItems?.length > 0 && (() => {
    const matchedItem = redeemableItems.find(
      i =>
        i.item_id?.toString() === item.item_id?.toString() ||
        i.item_id?.toString() === item._id?.toString()
    );

    // Only render if matchedItem exists and has coins
    if (matchedItem && matchedItem.coins > 0) {
      const netPrice = item.selling_price * item.quantity - matchedItem.coins;
      return (
        <span className="text-green-600 text-xs font-semibold ml-1">
          ₹{netPrice} + {matchedItem.coins}
          <img
            src={BuildCoin}
            alt="BuildCoin"
            className="h-4 w-4 inline-block ml-1"
          />
        </span>
      );
    }

    // Return null if no coins
    return null;
  })()}
</div>


        {/* Quantity display */}
        {item.quantity_changed ? (
          <div className="text-[11px] font-medium">
            <span className="text-gray-400 line-through mr-2">
              {orderedQty} {uomLabel}
            </span>
            <span className="text-[#092C83]">
              {confirmedQty} {uomLabel}
            </span>
          </div>
        ) : (
          <div className="text-[11px] text-[#092C83] font-medium">
            {confirmedQty} {uomLabel}
          </div>
        )}
      </div>

      {/* Price + right messages */}
      <div className="flex flex-col items-end ml-3 mt-2">
        {item.price_changed && item.initial_price ? (
          <>
            <div className="text-[10px] text-gray-400 line-through">
              ₹{Math.round(item.initial_price * confirmedQty).toLocaleString()}
            </div>
            <div className="text-[13px] font-bold text-[#170101]">
              ₹{Math.round(item.selling_price * confirmedQty).toLocaleString()}
            </div>
          </>
        ) : (
          <div className="text-[13px] font-bold text-[#170101]">
            ₹{Math.round(item.initial_price * confirmedQty).toLocaleString()}
          </div>
        )}

        {/* Right side messages */}
        <div className="mt-1 text-right space-y-0.5 max-w-[220px]">
          {isUnavailable && (
            <div className="text-[10px] text-[#B45309]">
              Item currently unavailable
            </div>
          )}
          {qtyDecreased && (
            <div className="text-[10px] text-[#92400E]">
              Available Quantity: {confirmedQty}
            </div>
          )}
        </div>
      </div>
    </div>
  );
})}

          </div>
        </div>
      );
    })
  )}
</div>


    {/* Bill Details Section - CartPreview Style */}
 <div className="mx-4 mb-2">
  <div className="bg-white rounded-md p-4 shadow-sm">
    {/* Header Title - Dynamic */}
    <h3 className="text-lg font-bold text-[#524D4D] mb-2">
      {quotationData.data_source === "sales_order" ? "Final Bill" : "Estimated Bill"}
    </h3>

    {/* Item Total */}
    <div className="flex justify-between items-center py-1">
      <div className="flex items-center">
        <img src={ListView} alt="Items" className="h-3 w-4 mr-1" />
        <span className="text-sm text-[#000000]">Item Total</span>
      </div>
      <span className="text-sm text-[#170101]">
        ₹{quotationData.subtotal?.toLocaleString()}
      </span>
    </div>

    {/* Delivery Charge - show only if status is "Order Confirmed" */}
    {quotationData.data_source === "sales_order" && (
      <div className="flex justify-between items-center py-1">
        <div className="flex items-center">
          <img src={DeliveFood} alt="Delivery" className="h-4 w-5 mr-1" />
          <span className="text-sm text-[#000000]">Delivery Charges</span>
        </div>
        <span className="text-sm text-[#170101]">₹200</span>
      </div>
    )}

    {/* Handling Charge - show only if status is "Order Confirmed" */}
    {quotationData.data_source === "sales_order" && (
      <div className="flex justify-between items-center py-1">
        <div className="flex items-center">
          <img src={ManualHandling} alt="Handling" className="h-4 w-5 mr-1" />
          <span className="text-sm text-[#000000]">Handling Charges</span>
        </div>
        <span className="text-sm text-[#170101]">₹10</span>
      </div>
    )}

    {/* BuildCoin Discount */}
    {/* {quotationData.discount > 0 && ( */}
    {checked && redeemableCoins > 0 && (quotationData.paymentStatus !== "payment timeout") && (
      <div className="flex justify-between items-center py-1">
        <div className="flex items-center">
          <img src={Coininhand} alt="BuildCoin" className="h-4 w-4 mr-1" />
          <span className="text-sm text-[#000000]">BuildCoins Discount</span>
        </div>
        <span className="text-sm text-[#14A311]">-₹{redeemableCoins}</span>
      </div>
    )}

    {/* GST */}
    <div className="flex justify-between items-center py-1">
      <div className="flex items-center">
        <img src={File} alt="GST" className="h-4 w-4 mr-1" />
        <span className="text-sm text-[#000000]">GST (18%)</span>
      </div>
      <span className="text-sm text-[#170101]">
        ₹{quotationData.tax_amount?.toLocaleString()}
      </span>
    </div>

    {/* Divider */}
    <div className="border-t border-gray-200 my-2"></div>

    {/* Grand Total */}
    <div className="flex justify-between items-center py-2">
      <span className="text-md font-bold text-[#524D4D]">Grand Total</span>
      <span className="text-md font-semibold text-[#170101]">
        ₹{computedGrandTotal.toLocaleString()}
      </span>
    </div>

    {/* Info Note - show only if NOT confirmed */}
    {/* quotationData.status !== "Order Confirmed" */ quotationData.data_source !== "sales_order" && (
      <div className="flex items-start pt-2 mb-1">
        <img src={Info} alt="Info" className="h-6 w-7 mr-1 mt-0.5 flex-shrink-0" />
        <span className="text-xs text-[#000000]">
          Prices shown are not final and may change slightly after supplier confirmation. Delivery charges will be added based on the supplier’s location.
        </span>
      </div>
    )}
  </div>
</div>


{/* Delivery Location Section - Separate, not sticky */}
<div className="mx-4 mb-4">
  <div className="bg-white rounded-md shadow-sm overflow-hidden">
    <div className="bg-gray-50 rounded-md">
      <div className="flex items-center p-2 transition-colors">
        {/* Icon */}
        <div className="flex-shrink-0 pl-1">
          {deliveryAddress?.address_type === 'project' ? (
            <img src={Building} alt="Building" className="h-12 w-12 object-contain" />
          ) : (
            <img src={Map} alt="Map" className="h-7 w-7 object-contain" />
          )}
        </div>

        {/* Address Info */}
        <div className="flex-1 py-2 pl-2 pr-2 min-w-0">
          {deliveryAddress ? (
            <>
              <p className="text-md text-[#000000]">
                {isDelivered ? "Delivered to " : "Delivering to "}
                <span className="text-[#000000] font-semibold">
                  {deliveryAddress.address_type === "project" ? "Project" : "Address"}
                </span>
              </p>

              <p className="text-xs text-[#000000] truncate">
                {deliveryAddress.address_type === 'project'
                  ? `${deliveryAddress.project_name}${deliveryAddress.area_sector_locality ? ', ' + deliveryAddress.area_sector_locality : ''}`
                  : deliveryAddress.area_sector_locality || ''}
              </p>
            </>
          ) : (
            <p className="text-sm text-[#000000]">Choose delivery address</p>
          )}
        </div>

        {/* Change/Choose Button */}
        {(() => {
          // Get the latest payment status
          const allNotifications = [...(notifications || []), ...(fetchedNotifications || [])];

          const quotationNotifications = allNotifications.filter(
            notif =>
              notif?.data?.order_id === quotationData._id ||
              notif?.order_id === quotationData._id ||
              notif?.entityId === quotationData._id ||
              notif?.metadata?.order_id === quotationData._id
          );

          const latestNotification = quotationNotifications.sort(
            (a, b) =>
              new Date(
                b.timestamp || b.createdAt || b.sentAt || b.metadata?.trigger_time || 0
              ) -
              new Date(
                a.timestamp || a.createdAt || a.sentAt || a.metadata?.trigger_time || 0
              )
          )[0];

          const currentPaymentStatus =
            latestNotification?.data?.payment_status ||
            latestNotification?.metadata?.payment_status ||
            quotationData.payment_status;

          // Only hide button if Paid or Payment Done
          const hideButton = ["paid", "payment done"].includes((currentPaymentStatus || "").toLowerCase());

          if (!hideButton) {
            return (
              <div className="flex-shrink-0 pl-2">
                <button
                  className="text-[#092C83] text-sm font-medium px-2 py-1 rounded-md transition-colors whitespace-nowrap hover:bg-gray-100"
                  onClick={() => setShowLocationPopup(true)}
                >
                  {deliveryAddress ? "Change" : "Choose"}
                </button>
              </div>
            );
          }

          return null;
        })()}
      </div>
    </div>
  </div>
</div>

{/* Saved BuildCoins Card - Only show if redeemableCoins > 0 */}
{checked && redeemableCoins > 0 && (
  <div className="fixed bottom-16 left-0 right-0 z-50 flex justify-center pointer-events-none">
    <div className="rounded-t-2xl overflow-hidden flex flex-col w-full max-w-md mx-auto pointer-events-auto">
  <div className="bg-green-300 flex items-center justify-center px-5 py-2 gap-3">
    {/* White circle with green tick */}
    <span className="inline-flex items-center justify-center rounded-full bg-white h-6 w-6 shadow">
      <svg className="w-4 h-4 text-green-500" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7"/>
      </svg>
    </span>
    <span className="text-green-800 font-base text-sm flex items-center">
      save upto&nbsp;
      <span className="mx-2 flex items-center font-bold text-base">
        <span className="font-semibold text-green-800 flex items-center">
          <span className=" ">₹</span>{redeemableCoins}
        </span>
      </span>
  {Number(rewardableCoins) > 0 && (
          <span className="font-semibold">
            + earn {rewardableCoins}
            <img
              src={BuildCoin}
              alt="BuildCoin"
              className="h-5 w-5 inline-block ml-1"
            />
          </span>
        )}
      <span className='mx-1'>on </span>
      <span className='font-semibold'>this order</span>
    </span>
  </div>
</div>

  </div>
)}

{/* Bottom Total Section - Sticky */}
<div className="sticky bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-40">
  <div className="p-3 flex justify-between items-center">
    {/* Left: Total - Hide based on notification status only */}
  {/* Left: Total - Hide based on notification status only */}

 {quotationData?.payment_status === "Pending" && (
  <div className="flex flex-col">
    <span className="text-md text-[#00000] ml-2">Total</span>
    <span className="text-lg font-bold ml-2">
      ₹{Math.round(quotationData.total)?.toLocaleString()}
    </span>
  </div>
)}



    {/* Right: Order Status and Cancel Button - Only show if payment NOT completed */}
    {!paymentCompleted && (
      <div className="flex justify-end">
        {(() => {
          // Combine real-time and fetched notifications
          const allNotifications = [
            ...(notifications || []),
            ...(fetchedNotifications || [])
          ];
                           
          // Filter for this quotation/order
          const quotationNotifications = allNotifications.filter(
            notif =>
              notif?.data?.order_id === `"${quotationData._id}"` ||
              notif?.data?.order_id === quotationData._id ||
              notif?.order_id === `"${quotationData._id}"` ||
              notif?.order_id === quotationData._id ||
              notif?.entityId === quotationData._id ||
              notif?.metadata?.order_id === quotationData._id
          );
                           
          // Get the latest notification (most recent first)
          const latestNotification = quotationNotifications.sort((a, b) =>
            new Date(
              b.timestamp ||
                b.createdAt ||
                b.sentAt ||
                b.metadata?.trigger_time ||
                0
            ) -
            new Date(
              a.timestamp ||
                a.createdAt ||
                a.sentAt ||
                a.metadata?.trigger_time ||
                0
            )
          )[0];
                           
          // Check payment status from notification data first, then fallback to quotationData
          const paymentStatus =
            latestNotification?.data?.payment_status ||
            latestNotification?.metadata?.payment_status ||
            quotationData.payment_status;
                           

    // Show pay button if payment_status is "Ready To Pay" AND showPayNowButton is true
    const showPayButton =
  paymentStatus === "Ready To Pay" && showPayNowButton;

return showPayButton ? (
<div className="flex items-center justify-between w-full rounded-lg px-2 py-2 gap-4">
  {/* urgency note - left side */}
  <p className="text-xs text-[#F84C5C] font-medium animate-pulse">
    One step left — make payment ⏳
  </p>

  {/* pay button - right side */}
  <button
    className="bg-[#F84C5C] text-white font-semibold px-4 py-2 rounded-md 
               disabled:opacity-50 disabled:cursor-not-allowed 
               flex items-center justify-center gap-2 
               transition transform hover:scale-105"
    disabled={payNowLoading}
    onClick={() => {
      setPayNowLoading(true);

      setTimeout(() => {
        setPayNowLoading(false);
        navigate("/consumer/paymentmethod", {
          state: {
            quotationData: quotationData,
            totalAmount: quotationData.total,
            quotationId: quotationData._id,
            quotationNumber: quotationData.quotation_number,
          },
        });
      }, 2000);
    }}
  >
    {payNowLoading ? (
      <div className="flex items-center justify-center">
        <img
          src={PhoneSpinner}
          alt="Loading"
          className="h-5 w-5 object-contain animate-spin mr-2"
        />
        Processing...
      </div>
    ) : (
      <>
        <Clock className="h-5 w-5" />
        <span>Pay Now</span>
      </>
    )}
  </button>
</div>

) : quotationData.status?.toLowerCase() === "payment timeout" ? (
  <div className=" text-center rounded-lg py-2 px-3 flex flex-col items-center">
    <XCircle className="h-8 w-8 text-red-500 mb-2" />
    <p className="text-md font-semibold text-gray-700">
      This order is no longer available.
    </p>
    <p className="text-sm text-gray-500 mt-1">
      Don’t worry — you can easily place a new order to continue.
    </p>
  </div>
) : (
  <button className="bg-[#F1F0F0] text-[#A8A1A1] font-semibold px-4 py-2 rounded-md whitespace-nowrap">
    Order Placed!
  </button>
);


        })()}
      </div>
    )}
  </div>
</div>


{showCancelPopup && (
  <>
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-50"
      onClick={() => setShowCancelPopup(false)}
    ></div>
    
    <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg z-50 w-80 max-w-[90vw] p-6">
      <p className="text-center text-lg text-gray-800 mb-6">
        Are you sure you want to cancel your order?
      </p>
      
      <div className="flex space-x-4">
        <button
          onClick={() => setShowCancelPopup(false)}
          className="flex-1 px-4 py-2 bg-gray-200 text-gray-700 font-medium rounded-lg"
        >
          No
        </button>
        <button
          onClick={() => {
            setShowCancelPopup(false);
            setShowCancelSection(false);
          }}
          className="flex-1 px-4 py-2 bg-red-500 text-white font-medium rounded-lg"
        >
          Yes
        </button>
      </div>
    </div>
  </>
)}


{showReturnPopup && (
  <>
    {/* Backdrop */}
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 z-50"
      onClick={() => setShowReturnPopup(false)}
    ></div>
    
    {/* Popup Content */}
    <div className="fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl z-50 max-w-md mx-auto max-h-[80vh] overflow-hidden">
      {/* Handle bar */}
      
      {/* Header */}
      <div className="flex items-center px-4 py-3 border-b border-gray-200">
        <button 
          onClick={() => setShowReturnPopup(false)}
          className="mr-3 p-1"
        >
          <img src={ArrowLeft} alt="Back" className="w-10 h-6" />
        </button>
        <h3 className="text-lg font-medium text-[#000000] flex-1 text-center mr-9">
          Return Items
        </h3>
      </div>
      
      {/* Instruction Text */}
      <div className="px-4 py-1">
        <p className="text-sm text-[#524D4D] font-medium text-center mt-4">
          Select the order items that you want to return
        </p>
      </div>
      
      {/* Items List */}
      <div className="flex-1 overflow-y-auto px-6 py-2 max-h-[50vh]">
        {quotationData.items && quotationData.items.map((item, index) => (
          <div key={index} className="flex items-center py-3 border-b border-gray-100 last:border-b-0">
            {/* Checkbox */}
            <div className="mr-3">
              <div className="relative">
                <input
                  type="checkbox"
                  id={`return-item-${item.item_id || index}`}
                  checked={selectedReturnItems.includes(item.item_id || index)}
                  onChange={() => handleReturnItemSelect(item.item_id || index)}
                  className="sr-only"
                />
                <div 
                  className={`w-4 h-4 rounded border flex items-center justify-center cursor-pointer ${
                    selectedReturnItems.includes(item.item_id || index)
                      ? 'bg-red-500 border-red-500' 
                      : 'border-red-400 hover:border-red-300'
                  }`}
                  onClick={() => handleReturnItemSelect(item.item_id || index)}
                >
                  {selectedReturnItems.includes(item.item_id || index) && (
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  )}
                </div>
              </div>
            </div>
            
            {/* Product Image */}
            <div className="bg-gray-100 rounded-md p-2 mr-3 flex-shrink-0">
              <img 
                src={imageUrl + item.item_image} 
                alt={item.item_name} 
                className="h-12 w-12 object-contain"
              />
            </div>
            
            {/* Product Details */}
            <div className="flex-1 min-w-0">
              <h4 className="text-[13px] text-[#000000] mb-1 line-clamp-2">
                {item.item_name}
              </h4>
              <div className="flex items-center justify-between">
               
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {/* Bottom Buttons */}
    <div className="px-4 py-4 bg-white flex space-x-3">
  <button
    onClick={() => {
      setShowReturnPopup(false);
      setSelectedReturnItems([]);
    }}
    className="flex-1 px-4 py-1 border border-gray-300 text-gray-600 font-semibold rounded-md hover:bg-gray-50 transition-colors"
  >
    Cancel
  </button>
  <button
    onClick={handleReturnSubmit}
    className="flex-1 px-4 py-1 font-semibold rounded-md transition-colors bg-red-500 text-white hover:bg-red-600"
  >
    Continue
  </button>
</div>

    </div>
  </>
)}

{showReasonPopup && (
  <>
    {/* Backdrop */}
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-70"
      onClick={() => setShowReasonPopup(false)}
    ></div>
    
    {/* Popup Content */}
    <div className="fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl z-50 max-w-md mx-auto max-h-[80vh] overflow-hidden">
      {/* Header */}
      <div className="flex items-center px-4 py-3 border-b border-gray-200">
        <button
          onClick={() => setShowReasonPopup(false)}
          className="mr-3 p-1"
        >
          <img src={ArrowLeft} alt="Back" className="w-10 h-6" />
        </button>
        <h3 className="text-lg font-medium text-[#000000] flex-1 text-center mr-9">
          Reason For Return
        </h3>
      </div>
      
      {/* Reasons List */}
      <div className="flex-1 overflow-y-auto px-4 py-4 max-h-[60vh]">
        {/* Wrong Item Delivered */}
        <div
          className={`border rounded-lg p-4 mb-3 cursor-pointer transition-colors ${
            selectedReason === 'wrong_item'
              ? 'border-red-500 bg-red-50'
              : 'border-gray-300 hover:border-gray-400'
          }`}
          onClick={() => handleReasonSelect('wrong_item')}
        >
          <div className="flex items-start">
            <div className="mr-3 mt-1">
              <input
                type="radio"
                name="returnReason"
                value="wrong_item"
                checked={selectedReason === 'wrong_item'}
                onChange={() => handleReasonSelect('wrong_item')}
                className="w-4 h-4 text-red-500 border-gray-400 focus:ring-red-500"
              />
            </div>
            <div className="flex-1">
              <h4 className="text-sm font-semibold text-[#000000] mb-1">
                Wrong Item Delivered
              </h4>
              <p className="text-xs text-gray-600">
                The product received is different from what was ordered.
              </p>
            </div>
          </div>
        </div>

        {/* Damaged Product */}
        <div
          className={`border rounded-lg p-4 mb-3 cursor-pointer transition-colors ${
            selectedReason === 'damaged'
              ? 'border-red-500 bg-red-50'
              : 'border-gray-300 hover:border-gray-400'
          }`}
          onClick={() => handleReasonSelect('damaged')}
        >
          <div className="flex items-start">
            <div className="mr-3 mt-1">
              <input
                type="radio"
                name="returnReason"
                value="damaged"
                checked={selectedReason === 'damaged'}
                onChange={() => handleReasonSelect('damaged')}
                className="w-4 h-4 text-red-500 border-gray-400 focus:ring-red-500"
              />
            </div>
            <div className="flex-1">
              <h4 className="text-sm font-medium text-[#000000] mb-1">
                Damaged Product
              </h4>
              <p className="text-xs text-gray-600">
                The product arrived broken, chipped, or unusable.
              </p>
            </div>
          </div>
        </div>

        {/* Quality Not as Expected */}
        <div
          className={`border rounded-lg p-4 mb-3 cursor-pointer transition-colors ${
            selectedReason === 'quality'
              ? 'border-red-500 bg-red-50'
              : 'border-gray-300 hover:border-gray-400'
          }`}
          onClick={() => handleReasonSelect('quality')}
        >
          <div className="flex items-start">
            <div className="mr-3 mt-1">
              <input
                type="radio"
                name="returnReason"
                value="quality"
                checked={selectedReason === 'quality'}
                onChange={() => handleReasonSelect('quality')}
                className="w-4 h-4 text-red-500 border-gray-400 focus:ring-red-500"
              />
            </div>
            <div className="flex-1">
              <h4 className="text-sm font-medium text-[#000000] mb-1">
                Quality Not as Expected
              </h4>
              <p className="text-xs text-gray-600">
                The material quality is not as per the specification or expectation.
              </p>
            </div>
          </div>
        </div>

        {/* Excess Quantity Delivered */}
        <div
          className={`border rounded-lg p-4 mb-3 cursor-pointer transition-colors ${
            selectedReason === 'excess_quantity'
              ? 'border-red-500 bg-red-50'
              : 'border-gray-300 hover:border-gray-400'
          }`}
          onClick={() => handleReasonSelect('excess_quantity')}
        >
          <div className="flex items-start">
            <div className="mr-3 mt-1">
              <input
                type="radio"
                name="returnReason"
                value="excess_quantity"
                checked={selectedReason === 'excess_quantity'}
                onChange={() => handleReasonSelect('excess_quantity')}
                className="w-4 h-4 text-red-500 border-gray-400 focus:ring-red-500"
              />
            </div>
            <div className="flex-1">
              <h4 className="text-sm font-medium text-[#000000] mb-1">
                Excess Quantity Delivered
              </h4>
              <p className="text-xs text-gray-600">
                More items were delivered than ordered.
              </p>
            </div>
          </div>
        </div>

        {/* Ordered by Mistake */}
        <div
          className={`border rounded-lg p-4 mb-3 cursor-pointer transition-colors ${
            selectedReason === 'mistake'
              ? 'border-red-500 bg-red-50'
              : 'border-gray-300 hover:border-gray-400'
          }`}
          onClick={() => handleReasonSelect('mistake')}
        >
          <div className="flex items-start">
            <div className="mr-3 mt-1">
              <input
                type="radio"
                name="returnReason"
                value="mistake"
                checked={selectedReason === 'mistake'}
                onChange={() => handleReasonSelect('mistake')}
                className="w-4 h-4 text-red-500 border-gray-400 focus:ring-red-500"
              />
            </div>
            <div className="flex-1">
              <h4 className="text-sm font-medium text-[#000000] mb-1">
                Ordered by Mistake
              </h4>
              <p className="text-xs text-gray-600">
                The order was placed in error.
              </p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Bottom Buttons */}
      <div className="px-4 py-4 bg-white border-t border-gray-200 flex space-x-3">
        <button
          onClick={() => {
            setShowReasonPopup(false);
            setSelectedReason('');
          }}
          className="flex-1 px-4 py-1 border border-gray-300 text-gray-600 font-semibold rounded-md hover:bg-gray-50 transition-colors"
        >
          Cancel
        </button>
        <button
          onClick={handleFinalReturnSubmit}
          className={`flex-1 px-4 py-1 font-semibold rounded-md transition-colors ${
            selectedReason
              ? 'bg-red-500 text-white hover:bg-red-600'
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }`}
          disabled={!selectedReason}
        >
          Submit Return
        </button>
      </div>
    </div>
  </>
)}



  </div>
);


};

export default OrderDetails;
